import React from "react";
import { motion } from "framer-motion";
import { SITE } from "../lib/site";

export default function WhatsAppFloat() {
  return (
    <motion.a
      data-testid="floating-whatsapp"
      href={SITE.bookingUrl}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Contactar por WhatsApp"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.6, type: "spring", stiffness: 200, damping: 18 }}
      whileHover={{ scale: 1.08 }}
      whileTap={{ scale: 0.95 }}
      className="fixed bottom-24 right-5 md:bottom-28 md:right-7 z-50 group"
    >
      {/* Pulsing halo */}
      <span className="absolute inset-0 rounded-full bg-[#25D366]/45 animate-ping" />
      <span className="absolute -inset-2 rounded-full bg-[#25D366]/30 blur-md" />

      {/* Button */}
      <span
        className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full text-white"
        style={{
          background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
          boxShadow:
            "0 8px 24px -4px rgba(37, 211, 102, 0.55), 0 16px 40px -10px rgba(18, 140, 126, 0.45), inset 0 1px 0 rgba(255,255,255,0.25)",
        }}
      >
        {/* Official WhatsApp glyph */}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 32 32"
          className="w-7 h-7 md:w-8 md:h-8 fill-current"
          aria-hidden="true"
        >
          <path d="M19.11 17.205c-.372 0-1.088 1.39-1.518 1.39a.63.63 0 0 1-.315-.1c-.802-.402-1.504-.817-2.163-1.447-.545-.516-1.146-1.29-1.46-1.963a.426.426 0 0 1-.073-.215c0-.33.99-.945.99-1.49 0-.143-.73-2.09-.832-2.335-.143-.372-.214-.487-.6-.487-.187 0-.36-.043-.53-.043-.302 0-.53.115-.746.315-.688.645-1.032 1.318-1.06 2.264v.114c-.015.99.472 1.977 1.017 2.78 1.23 1.82 2.506 3.41 4.554 4.34.616.287 2.035.888 2.722.888.817 0 2.15-.515 2.5-1.318.214-.486.214-.93.143-1.032-.114-.214-.42-.34-.78-.514M16 .017c-8.823 0-15.998 7.175-15.998 15.998 0 2.793.72 5.413 1.99 7.694l-2.022 7.29 7.45-1.946c2.196 1.158 4.71 1.83 7.378 1.83 8.823 0 15.998-7.175 15.998-15.998 0-8.825-7.176-15.998-16-15.998m0 28.5c-2.55 0-4.92-.74-6.93-2.04l-4.84 1.26 1.32-4.74C4.18 21.04 3.5 18.6 3.5 16c0-6.9 5.6-12.5 12.5-12.5s12.5 5.6 12.5 12.5-5.6 12.5-12.5 12.5" />
        </svg>
      </span>

      {/* Tooltip */}
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap rounded-full glass-strong px-4 py-2 text-xs text-brand-deep opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        Escríbeme por WhatsApp
      </span>
    </motion.a>
  );
}
